import { render, staticRenderFns } from "./FrzPalletMovimients.vue?vue&type=template&id=2de916e0"
import script from "./FrzPalletMovimients.vue?vue&type=script&lang=js"
export * from "./FrzPalletMovimients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports